var map = {
	"./AllThatApply.svg": 797,
	"./AppointmentScheduler.svg": 798,
	"./CalendarDate.svg": 799,
	"./FullText.svg": 800,
	"./MultipleChoice.svg": 801,
	"./Text.svg": 802,
	"./Time.svg": 803,
	"./TimeCalendar.svg": 804,
	"./TrueOrFalse.svg": 805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 796;